import clsx from 'clsx';
import React from 'react';

import { Icon } from '../Icon/Icon';

import { getStatusConfig } from './statusConfig';
import styles from './StatusTag.module.scss';

interface StatusTagProps {
  status: string;
  label?: string;
  showIcon?: boolean;
  showLabel?: boolean;
  className?: string;
}

export const StatusTag: React.FC<StatusTagProps> = ({
  status,
  label,
  showIcon = true,
  showLabel = true,
  className,
}) => {
  const config = getStatusConfig(status);

  return (
    <span className={clsx(styles.status, styles[`status-${config.tone}`], className)}>
      {showIcon && (
        <Icon
          className={styles.statusIcon}
          name={config.iconName}
        />
      )}
      {showLabel && (label ?? config.label)}
    </span>
  );
};
